import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl';

import Input from '../Input';
import { isValidVideoURL } from '../../utils/url';
import './styles.css';

const messages = defineMessages({
  notValidVideoUrl: {
    id: 'input.video.url',
    defaultMessage: 'Videos must be from Vimeo or Youtube',
  },
});

const VideoUrlInput = (props) => {
  const { value } = props;
  const showError = value && !isValidVideoURL(value);
  return (
    <section>
      <Input
        {...props}
      />
      {showError && (
      <div styleName="input-error">
        <FormattedMessage {...messages.notValidVideoUrl} />
      </div>
      )}
    </section>
  );
};

VideoUrlInput.propTypes = {
  value: PropTypes.string,
};

export default VideoUrlInput;
